import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import DealerListing from "../../components/DealerListing";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

//Redux

import * as sessionActions from "../../redux/dealers/actions";
import * as branchActions from "../../redux/branch/actions";

//Components

import BranchCreate from "../../components/CustomForm";
import DealerDetail from "../../components/DealerDetail";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowData: null,
    };
  }

  componentDidMount() {
    // this.props.actions.fetchCountry();
    // this.props.actions.fetchCountryBranch();
  }

  handleFetchDealer = (data) => {
    this.props.actions.fetchAllDealer(data);
  };

  handleFetchCountry = (data) => {
    this.props.actions.fetchCountry(data);
  };

  handleFetchState = (data) => {
    this.props.actions.fetchState(data);
  };

  handleFetchCity = (data) => {
    this.props.actions.fetchCity(data);
  };

  handleSingleDealerFetch = (data) => {
    this.props.actions.fetchSingleDealer(data);
  };

  handleDealerBranchFetch = (data) => {
    this.props.actions.fetchDealerBranch(data);
  };

  handleSelectedRowData = (selectedRowData) => {
    let state = this.state;
    state.selectedRowData = selectedRowData;
    this.setState({ ...state });
  };

  handleFetchBranchCountry = (data) => {
    this.props.actions.fetchCountryBranch(data);
  };

  handleFetchBranchState = (data) => {
    this.props.actions.fetchStateBranch(data);
  };

  handleFetchBranchCity = (data) => {
    this.props.actions.fetchCityBranch(data);
  };

  handleCreateBranch = (data) => {
    this.props.actions.createBranch(data);
  };

  handleClearPreviousReducers = () => {
    this.props.branchActions.clearPreviousReducer();
  };

  handleClearPreviousReducersForDealer = () => {
    this.props.actions.clearPreviousReducer();
  };

  render() {
    let { page } = this.props.match.params;
    switch (page) {
      case "list":
        return (
          <DealerListing
            handleFetchDealer={this.handleFetchDealer}
            handleFetchCountry={this.handleFetchCountry}
            handleClearPreviousReducersForDealer={
              this.handleClearPreviousReducersForDealer
            }
            handleFetchState={this.handleFetchState}
            handleSelectedRowData={this.handleSelectedRowData}
            handleFetchCity={this.handleFetchCity}
            countryStatus={this.props.countryStatus}
            countries={this.props.countries}
            stateStatus={this.props.stateStatus}
            states={this.props.states}
            cityStatus={this.props.cityStatus}
            cities={this.props.cities}
            dealerStatus={this.props.dealerStatus}
            dealerCount={this.props.dealerCount}
            dealers={this.props.dealers}
            elements={this.props.elements}
            handleSingleDealerFetch={this.handleSingleDealerFetch}
            handleDealerBranchFetch={this.handleDealerBranchFetch}
            query={this.props.location.search}
            selectedRowData={this.state.selectedRowData}
            dealerDataStatus={this.props.dealerDataStatus}
            dealerData={this.props.dealerData}
            dealerBranchDataStatus={this.props.dealerBranchDataStatus}
            dealerBranchData={this.props.dealerBranchData}
            accessibleCountries={this.props.accessibleCountries}
            userProfile={this.props.userProfile}
          />
        );

      case "detail":
        return (
          <DealerDetail
            handleSingleDealerFetch={this.handleSingleDealerFetch}
            handleDealerBranchFetch={this.handleDealerBranchFetch}
            query={this.props.location.search}
            selectedRowData={this.state.selectedRowData}
            dealerDataStatus={this.props.dealerDataStatus}
            dealerData={this.props.dealerData}
            dealerBranchDataStatus={this.props.dealerBranchDataStatus}
            dealerBranchData={this.props.dealerBranchData}
            elements={this.props.elements}
          />
        );

      case "create-branch":
        return (
          <BranchCreate
            handleFetchBranchCountry={this.handleFetchBranchCountry}
            handleClearPreviousReducers={this.handleClearPreviousReducers}
            handleFetchBranchState={this.handleFetchBranchState}
            handleFetchBranchCity={this.handleFetchBranchCity}
            handleCreateBranch={this.handleCreateBranch}
            handleSingleDealerFetch={this.handleSingleDealerFetch}
            page={page}
            query={this.props.location.search}
            dealerDataStatus={this.props.dealerDataStatus}
            dealerData={this.props.dealerData}
            countriesBranch={this.props.countriesBranch}
            statesBranch={this.props.statesBranch}
            citiesBranch={this.props.citiesBranch}
            createBranchStatus={this.props.createBranchStatus}
            elements={this.props.elements}
          />
        );

      default:
        return null;
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
    branchActions: bindActionCreators(branchActions, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    countryStatus: state.Dealer.countryStatus,
    countries: state.Global.countries,
    stateStatus: state.Dealer.stateStatus,
    states: state.Dealer.states,
    cityStatus: state.Dealer.cityStatus,
    cities: state.Dealer.cities,
    dealerStatus: state.Dealer.dealerStatus,
    dealerCount: state.Dealer.dealerCount,
    dealers: state.Dealer.dealers,
    countryBranchStatus: state.Dealer.countryBranchStatus,
    countriesBranch: state.Global.countries,
    stateBranchStatus: state.Dealer.stateBranchStatus,
    statesBranch: state.Dealer.statesBranch,
    cityBranchStatus: state.Dealer.cityBranchStatus,
    citiesBranch: state.Dealer.citiesBranch,
    dealerDataStatus: state.Dealer.dealerDataStatus,
    dealerData: state.Dealer.dealerData,
    dealerBranchDataStatus: state.Dealer.dealerBranchDataStatus,
    dealerBranchData: state.Dealer.dealerBranchData,
    createBranchStatus: state.Dealer.createBranchStatus,
    elements: state.Elements.elements,
    accessibleCountries: state.Auth.userProfile.accessibleCountries,
    userProfile: state.Auth.currentUserProfile,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
